import axios from 'axios';
import { useQuery } from "react-query";
import { htmlDecode, SITE_URL } from '../helperFunctions';

export function useCaseStudies(excludedId = null) {
  return useQuery(["caseStudies", excludedId], async () => {
    let url = `${SITE_URL}/wp-json/wp/v2/projects-api?per_page=50`;
    if (excludedId) url += `&exclude=${excludedId}`;
    
    const { data } = await axios.get(url)
    return data;
  }, { staleTime: 300000 });
}

export function useSingleCaseStudy(slug) {
  return useQuery(["caseStudy", slug], async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/projects-api?slug=${slug}`
    )

    return data[0]
  }, { staleTime: 300000 });
}

export function usePosts(excludedId = null) {
  return useQuery(["posts", excludedId], async () => {
    let url = `${SITE_URL}/wp-json/wp/v2/posts?per_page=100`
    if (excludedId) url += `&exclude=${excludedId}`

    const { data, headers } = await axios.get(url)
    const posts = data.map((item) => {
      if(item.title.rendered) {
        item.title.rendered = htmlDecode(item.title.rendered)
      }
      return item
    });

    return { headers, posts }
  }, { staleTime: 300000 });
}

export function useAllPosts(page, per_page = 10) {
  return useQuery(["posts", page, per_page], async () => {
    const { data, headers } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/posts?per_page=${per_page}&page=${page}&exclude=6088`
    )

    const posts = data.map((item) => {
      if(item.title.rendered) {
        item.title.rendered = htmlDecode(item.title.rendered)
      }
      return item
    });

    return { headers, posts }
  }, { keepPreviousData: true, staleTime: 300000 });
}

export function useSinglePost(slug) {
  return useQuery(["post", slug], async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/posts?slug=${slug}`
    )
    if (!data.length) return false;
  
    if(data[0].title.rendered) {
      data[0].title.rendered = htmlDecode(data[0].title.rendered)
    }

    return data[0]
  }, { staleTime: 300000 });
}

export function useLandingPage(slug) {
    return useQuery(["page", slug], async () => {
      const { data } = await axios.get(
        `${SITE_URL}/wp-json/wp/v2/pages?slug=${slug}&_fields=content,acf`
      )
  
      return data[0]
    }, { staleTime: 300000 });
  }

export function usePartnerInfo() {
  return useQuery('partner-info', async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/pages/10?_fields=acf`
    )

    return data.acf.partner.map((item) => ({
      name: item['partner_name'],
      url: item['partner_url'],
      imageUrl: item['partner_logo'].sizes.medium
    }))
  }, { staleTime: Infinity})
}

export function useProcessBlockInfo() {
  return useQuery('process-block-info', async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/pages/10?_fields=acf`
    )

    return data.acf.process_block.map((item) => ({
      title: item.title,
      copy: item.copy
    }))
  }, { staleTime: Infinity})
}

export function useServiceInfo() {
  return useQuery('service-info', async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/pages/10`
    )

    return data.acf.service.map((item) => ({
      title: item['service_title'],
      copy: item['service_copy'],
      label: item['link_label'],
      link: item['link_to']
    }))
  }, { staleTime: Infinity})
}

export function useHeroInfo() {
  const heroMap = {};
  return useQuery('hero-info', async () => {
    const { data } = await axios.get(
      `${SITE_URL}/wp-json/wp/v2/pages/?include=10,68,29,62,32,60,4330,4335,5185,5265,5811&_fields=title,acf,content,slug`
    )
    
    for(let i = 0; i < data.length; i++) {
      let heroTitle = htmlDecode(data[i].title.rendered);
      let heroHeadline = htmlDecode(data[i].acf['hero_headline']);
      let heroCopy = htmlDecode(data[i].acf['hero_copy']);
      let theContent = data[i].content.rendered;
      heroMap['/' + data[i].slug] = { heroTitle, heroHeadline, heroCopy, theContent }
    }

    return heroMap;
  }, { staleTime: Infinity})
}